// API configuration for LEI Alpha frontend
export const API_CONFIG = {
    // Base URL for API calls
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',

    // API endpoints
    endpoints: {
        search: '/api/v1/search',
        record: '/api/v1/record',
        facets: '/api/v1/facets',
        export: '/api/v1/export',
        stats: '/api/v1/stats',
        health: '/health'
    },

    // Request timeout (in milliseconds)
    timeout: 30000,

    // Retry configuration
    retry: {
        attempts: 3,
        delay: 1000
    }
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
    return `${API_CONFIG.baseURL}${endpoint}`;
};

// Helper function to check if running in container
export const isContainerized = (): boolean => {
    return (
        window.location.hostname === 'localhost' &&
        (window.location.port === '80' || window.location.port === '443')
    );
};

// Get the appropriate API base URL based on environment
export const getApiBaseUrl = (): string => {
    if (isContainerized()) {
        // If running in container, use relative URLs
        return '';
    }
    return API_CONFIG.baseURL;
};
